import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ol>
      <li parentName="ol">{`协议补全，通常我们在地址栏输入的URL都不会手动补全协议名，而是交给地址栏自动完成。 `}</li>
      <li parentName="ol">{`如输入www.baidu.com,最终请求URL为`}<a parentName="li" {...{
          "href": "https://www.baidu.com"
        }}>{`https://www.baidu.com`}</a></li>
      <li parentName="ol">{`网络进程：缓存存在直接返回，否则发送请求到服务端`}</li>
      <li parentName="ol">{`发请求需要知道目标主机和端口号，http默认端口号:80,https默认端口号:443`}</li>
      <li parentName="ol">{`主机和端口号从url获取，url可能是纯ip，也可能是域名`}</li>
      <li parentName="ol">{`如果是域名，就进行dns域名解析，涉及dns缓存`}</li>
      <li parentName="ol">{`tcp三次握手(https协议会有tls建立连接)`}</li>
      <li parentName="ol">{`解析url获取的ip端口号，浏览器端会构建请求行、请求头等信息，并把和该域名相关的Cookie等数据附加到请求头中，然后向服务器发送构建的请求信息。`}</li>
      <li parentName="ol">{`报文解析http->tcp->ip...    ... ip->tcp->http`}</li>
      <li parentName="ol">{`服务器处理，构建响应报文 (响应行、响应头和响应体)`}</li>
      <li parentName="ol">{`响应头包含location需要重定向处理`}</li>
      <li parentName="ol">{`Content-Type告知浏览器如何解析 `}</li>
      <li parentName="ol">{`解析html构建dom树`}</li>
      <li parentName="ol">{`解析css为styleSheets，样式标准化：rgb,bold:700,根据继承和层叠计算dom样式`}</li>
      <li parentName="ol">{`创建布局树(只包含可见元素)`}</li>
      <li parentName="ol">{`z-index,定位，浮动，分层，`}</li>
      <li parentName="ol">{`绘制`}</li>
      <li parentName="ol">{`栅格化处理`}</li>
      <li parentName="ol">{`GUI进程合成和显示`}</li>
      <li parentName="ol">{`四次挥手，断开连接`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      